$bog_builderui_alert $bog_builderui_card
	sub /
		<= Alert_title $mol_view sub /
			<= title \
		<= Alert_text $mol_view sub /
			<= text \
